import React from 'react'

export default React.createClass({

  getInitialState: function () {
    return {
      curAddressIndex: this.props.curIndex
    }
  },
  handleChange: function (index) {
    this.setState({curAddressIndex: index})
    if (this.props.onChange) {
      this.props.onChange(index)
    }
  },
  render: function () {
    let options = this.props.addresses.map((address, index) =>
      <li onClick={() => this.props.onChange(index)} key={index}><a>{address}</a></li>)
    let hiddenClass = 'dropdown'
    if (options.length === 1) {
      hiddenClass += ' hidden'
    }
    return (
      <div className={hiddenClass} style={{marginBottom: 20}}>
        <div type='button' id='dropdownMenu1' data-toggle='dropdown' className='clickable'>
          <h6 style={{display: 'inline'}}><a>{this.props.addresses[this.props.curIndex]}</a></h6>
          <i style={{marginLeft: 10}}className="fa fa-chevron-down"></i>
        </div>
        <ul className='dropdown-menu dropdown-menu-right' aria-labelledby='dropdownMenu1'>
          {options}
        </ul>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/shared/address.jsx